import { array, string, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';

/** Multi-select filter on the whole-house ancillary takeoffs a transaction
 *  contains. Values are ancillary item ids; a row matches when its ancillary
 *  set contains any of them (see the query builder's contains-any clause). */
export const AncillaryItems = struct({
	equalsType: EqualsType,
	values: array(string),
});
